export enum ReportsManagementGetters {
    GET_AVAILABILITY_REGISTRY_DATA = 'GET_AVAILABILITY_REGISTRY_DATA',
    GET_INCIDENT_REGISTRY_VIEW = 'GET_INCIDENT_REGISTRY_VIEW',
    GET_HISTORY_INCIDENTS = 'GET_HISTORY_INCIDENTS',
    GET_HISTORY_REPORTS = 'GET_HISTORY_REPORTS',
    GET_HISTORY = 'GET_HISTORY',
}
